import { Component, OnInit } from '@angular/core';
import { Faculty } from 'src/app/models/faculty.model';
import { FacultyService } from 'src/app/services/faculty/faculty.service';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
  history:Faculty[];
  constructor(private facultyService:FacultyService) { }

  ngOnInit(): void {
    this.history=this.facultyService.getHistory();
  }

}
